import React from 'react';
import { NavLink } from 'react-router-dom';
import NavItem from './NavItem';

export default function NavItemLink(props) {
    return <NavItem tag={NavLink} activeClassName={NavItem.styles.active} {...props} />;
}
